module.exports = __webpack_public_path__ + "linked-in-icon-small-cbe7bbf42c824ebdd8699afc8a649b20.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/linked-in-icon-small.svg
// module id = 93
// module chunks = 0